<template>
  <div>
    <LeftListMember :pos="10"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="/member-download-center" class="txt"
              >数据下载</router-link
            >
          </li>
          <li class="li">
            <router-link to="/member-task-center" class="txt">下载中心</router-link>
          </li>
<!--          <li class="li">-->
<!--            <router-link to="/member-search-center" class="txt">批量检索</router-link>-->
<!--          </li>-->
        </ul>
        <div class="contect">
          <div class="s-infobox">
            <!-- <div class="explain-top">
              <div class="explain-tit">说明</div>
              <div class="explain-txt">
                单次最大10000条；默认国图格式,GBK编码。<br />
              </div>
            </div> -->
            <div class="explain-down">
              <el-form ref="planform" :model="planform" :rules="planformRules" label-width="0px">
                <div class="plan">
                  <div class="submit-plan">
                    <div class="tit">任务名称</div>
                    <el-form-item label="" prop="title">
                      <el-input
                        v-model="planform.title"
                        placeholder="请输入任务名称"></el-input>
                      <!-- <el-button type="primary" @click="onSubmit">立即创建</el-button> -->
                    </el-form-item>
                    <el-button type="primary" class="btn" @click="save">提交任务</el-button>
                  </div>
                </div>
                <div class="text-content">
                  <div class="left">
                    <div class="select">
                      <div class="select-tit">选择书号文件</div>
                      <el-form-item label="" prop="isbnFile">
                        <file-upload :list.sync="fileList" :limit="10" accept=".txt">
                          <el-button size="small" type="primary">点击上传</el-button>
                        </file-upload>
                      </el-form-item>
                      <div class="isbn-file" v-if="fileList.length>0">{{fileList[0].name}}</div>
                    </div>
                    <div class="select mb">
                      <div class="select-tit">选择编码</div>
                      <el-form-item label="" prop="charset">
                        <el-radio-group v-model="planform.charset">
                          <el-radio label="gbk">GBK</el-radio>
                          <el-radio label="utf-8">UTF-8</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>

                    <div class="select">
                      <div class="select-tit">输出表单</div>
                      <el-form-item label="" prop="outputType">
                        <el-radio-group v-model="planform.outputType">
                          <el-radio label="none" value="">不输出</el-radio>
                          <el-radio label="default" value="">默认格式</el-radio>
                          <el-radio label="custom" value="">自定义格式</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>

<!--                    <div class="table-list">-->
<!--                      <div class="lab name">-->
<!--                        <div class="tit">标题名称</div>-->
<!--                        <div class="tit last">对应字段</div>-->
<!--                      </div>-->
<!--                      <div class="lab">-->
<!--                        <div class="tit">书&nbsp;&nbsp;&nbsp;号</div>-->
<!--                        <div class="tit last">010a</div>-->
<!--                      </div>-->
<!--                      <div class="lab">-->
<!--                        <div class="tit">正题名</div>-->
<!--                        <div class="tit last">010a</div>-->
<!--                      </div>-->
<!--                      <div class="lab">-->
<!--                        <div class="tit">出版年</div>-->
<!--                        <div class="tit last">010a</div>-->
<!--                      </div>-->
<!--                      <div class="lab">-->
<!--                        <div class="tit"></div>-->
<!--                        <div class="tit last"></div>-->
<!--                      </div>-->
<!--                    </div>-->
                    <el-table ref="fieldsTable" :data="z39Fields" :height="300" style="width: 400" @selection-change="handleSelectedFieldsChange" :header-cell-class-name="setClassName">
                      <el-table-column
                          v-if="planform.outputType === 'custom'"
                          type="selection"

                          align="center"></el-table-column>
                      <el-table-column prop="field_display_name" label="标题名称" ></el-table-column>
                      <el-table-column prop="field_name" label="对应字段" ></el-table-column>
                    </el-table>
                    <div class="table-tip">提示:可根据实际要求选择</div>

                  </div>
                  <div class="right">
                    <div class="select-tit">书号文件区域:</div>
<!--                    <file-upload :list.sync="fileList" :limit="10" accept=".txt" :drag="true" class="upload-demo">-->
<!--                      <div v-if="fileList.length === 0" class="el-upload__text" style="margin-top: 130px;">-->
<!--                        将txt格式文件拖到此处，或<em>点击上传</em>-->
<!--                      </div>-->
<!--                      <div v-else class="el-upload__text" style="padding: 10px;text-align: left;">-->
<!--                        <p v-for="(file, index) in fileList" :key="index">-->
<!--                          {{ file.name }}-->
<!--                        </p>-->
<!--                      </div>-->
<!--                    </file-upload>-->
                    <textarea v-model="planform.isbnString" class="el-upload__text" style="width: 400px; height: 500px; border:solid 1px lightgrey; border-radius: 5px; padding: 10px;text-align: left;margin: 5px 0;background-color: #EDF3F9;" @paste="handlePaste" placeholder="在此处粘贴ISBN书号，每行一个（上传文件时此处可不填）"></textarea>
                  </div>
                  <div class="left right2">
                    <div class="select-tit">服务器列表区</div>
                    <el-form-item label="" prop="serverIds">
                      <el-table
                        :data="servers"
                        style="width: 100%"
                        @selection-change="handleServerSelectionChange">
                        <el-table-column
                          type="selection"
                          width="55"
                          align="center"></el-table-column>
                        <el-table-column label="服务器名称" min-width="200">
                          <template slot-scope="scope">
                            <div class="server-cell">
                              <!-- <div class="server-icon">
                                <i class="el-icon-s-data"></i>
                              </div> -->
                              <span>{{ scope.row.name }}</span>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="优先级"
                          width="120"
                          align="center">
                          <template slot-scope="scope">
                            <div class="priority-cell">
                              <span
                                :class="[
                                  'priority-badge',
                                  `priority-${scope.row.sort}`,
                                ]">
                                {{ scope.row.sort }}
                              </span>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form-item>

                    <div v-if="servers.length === 0" class="empty-message">
                      <i class="el-icon-s-release"></i>
                      <p>暂无服务器数据，请点击"新增"按钮添加服务器</p>
                    </div>

                    <div class="buttons-container">
                      <button
                        class="action-button add-btn"
                        @click="openAddDialog">
                        新增
                      </button>

                      <button
                        class="action-button edit-btn"
                        :disabled="selectedServers.length !== 1"
                        @click="handleEdit">
                        修改
                      </button>

                      <button
                        class="action-button delete-btn"
                        :disabled="selectedServers.length === 0"
                        @click="deleteSelected">
                        删除
                      </button>
                    </div>
                    <div class="table-tip line">提示:可根据实际要求填写</div>
                  </div>
                </div>
              </el-form>
            </div>
            <!-- <div class="table-line"></div> -->

          </div>
          <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="600px"
            :close-on-click-modal="false">
            <el-form
              :model="form"
              :rules="formRules"
              ref="form"
              label-width="150px">
              <el-form-item label="服务器名称" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入服务器名称"></el-input>
              </el-form-item>
              <el-form-item label="服务器地址" prop="uri">
                <el-input
                  v-model="form.uri"
                  placeholder="请输入服务器地址"></el-input>
              </el-form-item>
              <el-form-item label="端口" prop="port">
                <el-input
                  v-model="form.port"
                  type="number"
                  placeholder="请输入端口"></el-input>
              </el-form-item>
              <el-form-item label="数据库" prop="database">
                <el-input
                  v-model="form.database"
                  placeholder="请输入数据库"></el-input>
              </el-form-item>
              <el-form-item label="用户名" prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model="form.password"
                  placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="顺序" prop="sort">
                <el-input
                  v-model="form.sort"
                  type="number"
                  placeholder="请输入顺序"></el-input>
              </el-form-item>
              <el-form-item label="查到单库数据就返回" prop="isSingleDb">
                <el-switch v-model="form.isSingleDb"></el-switch>
              </el-form-item>
<!--              <el-form-item label="单个任务最大下载条数" prop="singleTaskLimit">-->
<!--                <el-input-->
<!--                    v-model="form.singleTaskLimit"-->
<!--                    type="number"-->
<!--                    placeholder="请输入单个任务最大下载条数"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="下载间隔（秒）" prop="downloadInterval">-->
<!--                <el-slider v-model="form.downloadInterval" :step="0.5" :min="0.5" :max="5" :show-input="true"></el-slider>-->
<!--              </el-form-item>-->

<!--              <el-form-item label="优先级" prop="priority">-->
<!--                <el-select-->
<!--                  v-model="form.sort"-->
<!--                  placeholder="请选择优先级"-->
<!--                  style="width: 100%">-->
<!--                  <el-option label="高 (1)" :value="1"></el-option>-->
<!--                  <el-option label="中 (2)" :value="2"></el-option>-->
<!--                  <el-option label="低 (3)" :value="3"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
            </el-form>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submitForm">确 定</el-button>
            </span>
          </el-dialog>
          <!-- <div class="m-infobox5">
            <div class="box1">
              <img src="@/assets/images/icon1.png" class="icon" alt="" />
              <div
                class="tit"
                @click="protocol.show = true"
                style="cursor: pointer">
                《企业VIP服务协议》
              </div>
            </div>
            <router-link to="/info-recharge" class="link"
              >开通/续费企业VIP</router-link
            >
            <div class="box2">
              <div class="left" v-if="isVip">
                <img src="@/assets/images/icon2.png" class="icon" alt="" />
                <div class="tit">
                  会员VIP有效期：<span>{{
                    userInfo.vipTime.split(" ")[0]
                  }}</span>
                </div>
              </div>
              <div class="right" v-else>您还未开通企业VIP权限</div>
            </div>
            <div class="box3">
              <div class="top">
                <div class="tit">会员权益</div>
              </div>
              <div
                class="txt"
                v-html="$store.state.config.bk_supplier_vip_description"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <protocol-dialog
      :show.sync="protocol.show"
      :type="protocol.type"></protocol-dialog>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import ProtocolDialog from "@/components/ProtocolDialog.vue";
import dayjs from "dayjs";
import getApiData, {getApiRes, sleep} from "@/api/apiUtil";
import apiBkServer from "@/api/bkServer";
import FileUpload from "@/views/common/FileUpload.vue";
import apiBkDownloadTask from "@/api/bkDownloadTask";
import LeftListMember from "@/components/LeftListMember.vue";
import {upload} from "@/utils/request";
export default {
  components: {
    LeftListMember,
    FileUpload,
    ProtocolDialog,
    LeftListSupplier,
  },
  data() {
    return {
      protocol: {
        type: "bk_supplier_vip",
        show: false,
      },
      // 任务名称
      servers: [
        // { id: 1, name: "布克云", priority: 1 },
        // { id: 2, name: "国家图书馆", priority: 2 },
        // { id: 3, name: "58marc", priority: 3 },
      ],
      selectedServers: [],
      z39Fields: [
        // {
        //   "field_display_name": "一般性附注",
        //   "field_name": "300a",
        //   "field_value": "",
        //   "ismust": "0"
        // }
      ],
      selectedFields: [],
      dialogVisible: false,
      dialogType: "add",
      form: {
        id: undefined,
        name: "",
        uri:'',
        port: '',
        sort: 0,
        database: '',
        username: '',
        password: '',
        isSingleDb: true,
        singleTaskLimit: 10000,
        downloadInterval: 1,
      },
      formRules: {
        name: [
          { required: true, message: "请输入服务器名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        uri: [{ required: true, message: "请输入服务器地址", trigger: "blur" },],
        port: [{ required: true, message: "请输入端口", trigger: "blur" },],
        sort: [{ required: true, message: "请输入顺序", trigger: "blur" },],
        database: [{ required: true, message: "请输入数据库", trigger: "blur" },],
        username: [{ required: true, message: "请输入用户名", trigger: "blur" },],
        password: [{ required: true, message: "请输入密码", trigger: "blur" },],
        // singleTaskLimit: [{ required: true, message: "请输入单个任务下载限额", trigger: "blur" },],
        // downloadInterval: [{ required: true, message: "请选择下载间隔", trigger: "blur" },],
        // priority: [
        //   { required: true, message: "请选择优先级", trigger: "change" },
        // ],
      },
      nextId: 4,
      planform: {
        title: '',
        isbnFile: '', // 书号文件，多个文件逗号分隔
        isbnString: '', // 书号字符串，多个文件换行分隔
        charset: "gbk",
        outputType: "default",
        outputFields: [], // json
        serverIds: '', // 服务器id，多个id逗号分隔
        status: 0,
      },
      planformRules: {
        title: [ { required: true, message: "请输入任务名称", trigger: "blur" },],
        // isbnFile: [ { required: true, message: "请上传书号文件", trigger: "blur" },],
        charset: [ { required: true, message: "请选择编码", trigger: "blur" },],
        outputType: [ { required: true, message: "请选择输出格式", trigger: "blur" },],
        // outputFields: [ { required: true, message: "请选择输出字段", trigger: "blur" },],
        serverIds: [ { required: true, message: "请选择服务器", trigger: "blur" },],
      },
      planinput: "",
      fileList: [
      ],
    };
  },
  computed: {
    dialogTitle() {
      return this.dialogType === "add" ? "新增服务器" : "修改服务器";
    },

    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isVip() {
      return (
        dayjs(this.$store.state.user.userInfo.vipTime).unix() > dayjs().unix()
      );
    },
  },
  watch: {
    fileList(v){
      this.planform.isbnFile = v.map(x=>x.response.url).join(',')
    },
    selectedFields(v){
      this.planform.outputFields = v.map(x=>({field_display_name: x.field_display_name, field_name: x.field_name}))
    },
    selectedServers(v){
      this.planform.serverIds = v.map(x=>x.id).join(',')
    },
    'planform.outputType'(v){
      console.log(v)
      if(v === 'custom') {
        this.planform.outputFields = []
        this.$refs.fieldsTable.clearSelection()
      }else if(v === 'default') {
        this.planform.outputFields = this.z39Fields.filter(x=>['010a','200a','210a','210d','690a'].indexOf(x.field_name) > -1)
        this.selectedFields = this.planform.outputFields
        this.planform.outputFields.forEach(row =>{
          this.$refs.fieldsTable.toggleRowSelection(row)
        })
      }else if(v === 'none') {
        this.planform.outputFields = []
        this.$refs.fieldsTable.clearSelection()
      }
    }
  },
  mounted() {
    if(!this.isVip) {
      return this.$alert('开通VIP会员后才能使用下载功能', '提示', {callback: () => this.$router.push('/member-task-center')})
    }
    this.loadServers();
    this.loadZ39Fields()
    document.addEventListener('paste',this.handlePaste)
  },
  beforeDestroy() {
    document.removeEventListener('paste',this.handlePaste)
  },
  methods: {
    async loadServers(){
      this.servers = await getApiData(apiBkServer.getList(1, 100),0, 1)
    },
    async loadZ39Fields(){
      this.z39Fields = await getApiData(apiBkServer.getZ39Fields(),0, 0)
    },
    async save(){
      // if(this.planform.outputType != 'none' && this.planform.outputFields.length === 0) return this.$message.error('请选择输出字段')
      this.$refs.planform.validate(async (valid) => {
        if (valid) {
          const res = await getApiRes(apiBkDownloadTask.save(this.planform), 0, 1,1,1)
          if(res.code === 0) {
            this.fileList = [] // 清空文件列表
            await sleep(1000)
            this.$router.push({ path: '/member-task-center' });
          }
        }
      })
    },
    // 监听粘贴操作
    async handlePaste(event) {
      console.log('paste', event)
      const items = (event.clipboardData || window.clipboardData).items
      let files = []
      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持粘贴文件')
        return
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        let file = items[i].getAsFile()
        if (!file) {
          console.error('上传失败,粘贴的内容不是文件 ')
          return
        }
        if(!file.name.endsWith('.txt')){
          this.$message.error('上传文件格式错误，只能上传txt文件')
          return
        }
        files.push(file)
      }

      // if (files.length + this.fileList.length > this.limit) {
      //   this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`)
      //   return
      // }
      for (let i = 0; i < files.length; i++) {
        let fileItem = {
          name: files[i].name,
          raw: files[i]
        }
        let re = await getApiRes(upload(files[i]),1,1,1, 0)
        if(re.code==1){
          fileItem.response = {code: 1, name:files[i].name, url:re.url}
          this.fileList.push(fileItem)
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传10个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleServerSelectionChange(rows) {
      this.selectedServers = rows;
    },
    handleSelectedFieldsChange(rows) {
      this.selectedFields = rows;
    },
    openAddDialog() {
      this.dialogType = "add";
      this.form = {
        id: null,
        name: "",
        priority: null,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    handleEdit() {
      if (this.selectedServers.length === 1) {
        if(this.selectedServers[0].type !== 'user') return this.$message.error('系统服务器不允许修改')
        this.dialogType = "edit";
        this.form = Object.assign({}, this.selectedServers[0]);
        this.form.isSingleDb = this.form.isSingleDb == 1
        this.dialogVisible = true;
      }else{
        this.$message.error('请选择一条记录操作')
      }
    },
    deleteSelected() {
      if (this.selectedServers.length === 0) return;

      const names = this.selectedServers.map((r) => r.name).join(", ");
      this.$confirm(
        `确定要删除选中的 ${this.selectedServers.length} 个服务器吗?<br>${names}`,
        "删除确认",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(async () => {
          const ids = this.selectedServers.map((r) => r.id);
          const re = await getApiRes(apiBkServer.listDel(ids.join(',')))
          if(re.code == 0) {
            this.servers = this.servers.filter((item) => !ids.includes(item.id));
            this.selectedServers = [];
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        })
        .catch(() => {});
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.dialogType === "add") {
            // 新增服务器
            // this.form.id = this.nextId++;
            // this.servers.push(Object.assign({}, this.form));
            // this.$message({
            //   type: "success",
            //   message: "服务器添加成功!",
            // });
            const res = await getApiRes(apiBkServer.save(this.form), 0, 1,1,1)
            if(res.code === 0) {
              this.loadServers()
            }
          } else {
            // 修改服务器
            const index = this.servers.findIndex(
              (item) => item.id === this.form.id
            );
            if (index !== -1) {
              const res = await getApiRes(apiBkServer.save(this.form), 0, 1,1,1)
              if(res.code === 0) {
                this.loadServers()
              }
              this.servers.splice(index, 1, Object.assign({}, this.form));
              // this.$message({
              //   type: "success",
              //   message: "服务器信息已更新!",
              // });
            }
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    setClassName(column){
      if (column.column.type == "selection" && this.planform.outputType != 'custom') {
        return "all-disabled";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .all-disabled .el-checkbox__input .el-checkbox__inner {
  background-color: #edf2fc;
  border-color: #dcdfe6;
  cursor: not-allowed;
}
.isbn-file{
  padding: 3px;
  display: inline-block;
  width: 200px;
  height: 38px;
  line-height: 32px;
  font-size: 14px;
  overflow: hidden;
  border: solid 1px lightgrey;
  background-color: #F1F5F8;
}
</style>
